import CloseButton from '@/pages/new-platform/components/CloseButton';
import { Question } from '@/utils/api-objects/Question';

interface SurveyHeaderProps {
    currentQuestion: Question;
    progressPercentage: number;
    onClose: () => void;
}

export const SurveyHeader: React.FC<SurveyHeaderProps> = ({
    currentQuestion,
    progressPercentage,
    onClose,
}) => {
    return (
        <div className="w-full py-4 flex-none border-b border-solid border-black">
            <div className="mx-auto flex flex-col p-4">
                <div className="w-full flex items-center justify-between mb-[20px]">
                    <div className="flex items-center">
                        <img className="mr-[10px]" src="/images/new-platform/logos/holifya-logo-no-text.svg" alt="holifya-logo" />
                        <div className="font-bold text-[12px] leading-[17px]">Questionario | Health Assessment</div>
                    </div>
                    <CloseButton onClick={onClose} />
                </div>

                {/* Progress bar */}
                <div className="w-full h-[4px] bg-holifya-light-blue mb-[20px]">
                    <div className="w-full h-[4px] bg-holifya-blue" style={{ width: `${progressPercentage}%` }} />
                </div>

                {/* Question Title and Subtitle */}
                <div className="font-normal text-[20px] leading-[28px]">
                    {currentQuestion.question_text}
                </div>
                {currentQuestion.question_subtitle && (
                    <div className="font-bold text-[12px] leading-[17px] mt-[10px]">
                        {currentQuestion.question_subtitle}
                    </div>
                )}
            </div>
        </div>
    );
}; 